import dynamic from "next/dynamic";

import {
  BlockButton,
  BlockButtonParams,
  BlockButtonTopEditor,
} from "@splitfire-agency/raiden-le-editeur/dist/BlockButton";
import BlockButtonChakra from "@splitfire-agency/raiden-le-editeur/dist/BlockButtonChakra";
import {
  BlockCode,
  BlockCodeEditor,
} from "@splitfire-agency/raiden-le-editeur/dist/BlockCode";
import BlockCodeChakra from "@splitfire-agency/raiden-le-editeur/dist/BlockCodeChakra";
import {
  BLOCK_BUTTON,
  BLOCK_CODE,
  BLOCK_SPACER,
  BLOCK_TEXT,
  BLOCK_VIDEO,
} from "@splitfire-agency/raiden-le-editeur/dist/blocks";
import {
  BlockSpacer,
  BlockSpacerEditorTop,
} from "@splitfire-agency/raiden-le-editeur/dist/BlockSpacer";
import BlockSpacerChakra from "@splitfire-agency/raiden-le-editeur/dist/BlockSpacerChakra";
import { BlockText } from "@splitfire-agency/raiden-le-editeur/dist/BlockText";
import BlockTextChakra from "@splitfire-agency/raiden-le-editeur/dist/BlockTextChakra";
import {
  BlockVideo,
  BlockVideoParams,
  BlockVideoTopEditor,
} from "@splitfire-agency/raiden-le-editeur/dist/BlockVideo";
import BlockVideoChakra from "@splitfire-agency/raiden-le-editeur/dist/BlockVideoChakra";
import {
  SfIconButton,
  SfIconCode,
  SfIconSpacer,
  SfIconText,
  SfIconVideo,
} from "@splitfire-agency/raiden-le-editeur/dist/icons";
import { defineMessage } from "react-intl";

const BlockTextEditor = dynamic(
  () => import("@splitfire-agency/raiden-le-editeur/dist/BlockTextEditor"),
  {
    ssr: false,
  },
);

// Editor tools

export const POSTS_FRONT_EDITOR_TOOL_LIST = [
  {
    name: "Button",
    icon: SfIconButton,
    block: BLOCK_BUTTON,
    component: BlockButton,
    editorTop: BlockButtonTopEditor,
    params: BlockButtonParams,
  },
  {
    name: "Video",
    icon: SfIconVideo,
    block: BLOCK_VIDEO,
    component: BlockVideo,
    editorTop: BlockVideoTopEditor,
    params: BlockVideoParams,
  },
  {
    name: "Code",
    icon: SfIconCode,
    block: BLOCK_CODE,
    component: BlockCode,
    editor: BlockCodeEditor,
  },
  {
    name: "Spacer",
    icon: SfIconSpacer,
    block: BLOCK_SPACER,
    component: BlockSpacer,
    editorTop: BlockSpacerEditorTop,
  },
  {
    name: "TextEditor",
    icon: SfIconText,
    block: BLOCK_TEXT,
    component: BlockText,
    editor: BlockTextEditor,
  },
];

export const POSTS_FRONT_EDITOR_RENDERER_TOOL_LIST = [
  {
    name: "Button",
    block: BLOCK_BUTTON,
    component: BlockButtonChakra,
  },
  {
    name: "Video",
    block: BLOCK_VIDEO,
    component: BlockVideoChakra,
  },
  {
    name: "Code",
    block: BLOCK_CODE,
    component: BlockCodeChakra,
  },
  {
    name: "Spacer",
    block: BLOCK_SPACER,
    component: BlockSpacerChakra,
  },
  {
    name: "TextEditor",
    block: BLOCK_TEXT,
    component: BlockTextChakra,
  },
];

export const postsFrontEditorToolMessage = defineMessage({
  id: "raiden.library.constants.posts.frontEditorTool",
  defaultMessage:
    "{tool, select, Button {Bouton} Code {Code} Image {Image} Spacer {Espacement} TextEditor {Éditeur de texte} Video {Vidéo} other {{type}}}",
});

export const POSTS_FRONT_EDITOR_COLOR_PALETTE_LIST = [
  "#2D3748",
  "#CBD5E0",
  "#FFFFFF",
  "#2C75BA",
  "#EAA82F",
];
